import { Card, InfoRow } from './BmsCardPrimitives'

const TemperatureStatsCard = ({ bms, className = '' }) => (
  <Card className={className}>
    <InfoRow label="AFE temperature" value={bms.afeTemperature} />
    <InfoRow label="Board temperature" value={bms.boardTemperature} />
    <InfoRow label="MOSFET temperature" value={bms.mosfetTemperature} />
    <InfoRow label="Shunt temperature" value={bms.shuntTemperature} />
    <InfoRow label="Precharge temperature" value={bms.prechargeTemperature} />
    <InfoRow label="Balancing temperature" value={bms.balancingTemperature} />
  </Card>
)

export default TemperatureStatsCard
